import React from 'react';
import { WifiOff, RefreshCw, Cloud, CloudOff } from 'lucide-react';
import { useOffline, useServiceWorker } from '../hooks/useOffline';
import { Button } from '../components/ui/button';

const OfflineIndicator = () => {
  const { isOnline, pendingSync, syncPendingData } = useOffline();
  const { updateAvailable, updateServiceWorker } = useServiceWorker();

  if (isOnline && !pendingSync && !updateAvailable) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {/* Offline Banner */}
      {!isOnline && (
        <div 
          className="flex items-center gap-2 bg-amber-600 text-white px-4 py-2 rounded-lg shadow-lg"
          data-testid="offline-indicator"
        >
          <WifiOff className="h-4 w-4" />
          <span className="text-sm font-medium">Mode hors ligne</span>
        </div>
      )}

      {/* Pending Sync Badge */}
      {pendingSync > 0 && (
        <div 
          className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg cursor-pointer hover:bg-blue-700"
          onClick={syncPendingData}
          data-testid="pending-sync-badge"
        >
          {isOnline ? (
            <Cloud className="h-4 w-4" />
          ) : (
            <CloudOff className="h-4 w-4" />
          )}
          <span className="text-sm font-medium">
            {pendingSync} en attente de synchronisation
          </span>
          {isOnline && (
            <RefreshCw className="h-4 w-4 animate-spin" />
          )}
        </div>
      )}

      {/* Update Available */}
      {updateAvailable && (
        <div className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg">
          <span className="text-sm font-medium">Mise à jour disponible</span>
          <Button 
            size="sm" 
            variant="secondary" 
            onClick={updateServiceWorker}
            className="h-6 text-xs"
          >
            Mettre à jour
          </Button>
        </div>
      )}
    </div>
  );
};

export default OfflineIndicator;
